/**
 * MY — Change Officer 카테고리의 Register Detail 매핑.
 *   M32105 Appointment of Director.
 *
 * TASK_DATA.formData 는 PreSetChangeOfficerPanel 의 officerData 형태
 *   (directors[] 배열 + 회사 필드) 를 사용한다. 디렉터 2명+ 는 탭으로 구분 (AOS 와 동일).
 *   레거시(단일 director, newDirector* flat) 도 fallback 키로 지원.
 */
import { registerRegisterDetail } from '@/features/startTask/preset_task/shared/preset/register/registerDetailRegistry';
import { lookupB15Label } from '@/features/startTask/preset_task/shared/preset/lookups/b15NationalityCache';
import { formatDocDate } from '@/shared/composables/dateUtils';

// Nationality 라벨 resolver — directors.0.nationality 가 비어있고 nationalityCd 만 있으면 B15 캐시 lookup.
function formatNationality(raw: any): string {
  const s = String(raw || '').trim();
  if (!s) return '';
  if (!/^B15\d+/i.test(s)) return s;
  return lookupB15Label(s);
}

// 세션 dateFormat 으로 통일 (예: "1982-11-11" → "11/11/1982" 등).
function formatSessionDate(raw: any): string {
  const s = String(raw || '').trim();
  if (!s) return '';
  try { return formatDocDate(s) || s; } catch { return s; }
}

registerRegisterDetail('M32105', {
  title: 'New Director Details',
  repeatArrayPath: 'directors',
  fields: [
    { label: 'Full Name', key: ['directors.0.fullName', 'newDirectorFullName'] },
    { label: 'NRIC / Passport No', key: ['directors.0.nricOrPassport', 'newDirectorNricOrPassport'] },
    { label: 'Passport Expiry', key: ['directors.0.passportExpiryDate', 'newDirectorPassportExpiryDate'], format: formatSessionDate },
    { label: 'Date of Birth', key: ['directors.0.dateOfBirth', 'newDirectorDateOfBirth'], format: formatSessionDate },
    { label: 'Gender', key: ['directors.0.gender', 'newDirectorGender'] },
    { label: 'Race', key: ['directors.0.race', 'newDirectorRace'] },
    {
      label: 'Nationality',
      key: ['directors.0.nationality', 'newDirectorNationality', 'directors.0.nationalityCd'],
      format: formatNationality,
    },
    { label: 'Business / Occupation', key: ['directors.0.businessOccupation', 'newDirectorOccupation'] },
    {
      label: 'Date of Appointment',
      key: ['directors.0.dateOfAppointment', 'newDirectorAppointmentDate', 'appointedDate'],
      format: formatSessionDate,
    },
    { label: 'Residential Address', key: ['directors.0.residentialAddress', 'newDirectorResidentialAddress'] },
    { label: 'Contact Address', key: ['directors.0.serviceAddress', 'newDirectorServiceAddress'] },
  ],
});
